import { Article } from '../data/articles';

const articlesApiBase = (): string => {
  const apiUrl = process.env.REACT_APP_ARTICLES_API_URL;
  if (!apiUrl) {
    throw new Error('REACT_APP_ARTICLES_API_URL is not set');
  }
  return apiUrl.replace(/\/$/, '');
};

export const fetchArticles = async (): Promise<Article[]> => {
  const res = await fetch(`${articlesApiBase()}/articles`);
  if (!res.ok) {
    throw new Error('Failed to fetch articles');
  }
  const data = (await res.json()) as { articles?: Article[] };
  if (!Array.isArray(data.articles)) {
    throw new Error('Invalid articles response');
  }
  return data.articles;
};

export const fetchArticle = async (id: string): Promise<Article | null> => {
  const res = await fetch(`${articlesApiBase()}/articles/${encodeURIComponent(id)}`);
  if (res.status === 404) {
    return null;
  }
  if (!res.ok) {
    throw new Error('Failed to fetch article');
  }
  const data = (await res.json()) as { article?: Article };
  if (!data.article) {
    return null;
  }
  return data.article;
};
